<template>
  <div class="vehicleSlider" :ref="`vehicleSlider-${id}`">
    <div class="vehicleSlider__track" data-slider-track @scroll="setSlideNavigation">
      <div v-for="(image, index) in images" :id="`slide-${id}-${index}`" class="vehicleSlider__slide" :data-slider-slide="index">
        <img :src="image" :alt="`${title} ${index + 1}`" loading="lazy" class="vehicleSlider__image" />
      </div>
    </div>
    <a href="#" data-button-next class="vehicleSlider__controls prev" @click.prevent="slideToPrev"></a>
    <a :href="`#slide-${id}-1`" data-button-prev class="vehicleSlider__controls next" @click.prevent="slideToNext"></a>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    images: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: () => 'image',
    },
  },
  data() {
    return {
      slides: null,
      buttonNext: null,
      buttonPrev: null,
      prevSlide: null,
      nextSlide: null,
    }
  },
  mounted() {
    this.initSlider()
  },
  methods: {
    initSlider() {
      this.slides = this.$refs[`vehicleSlider-${this.id}`].querySelectorAll('[data-slider-slide]')
      this.buttonNext = this.$refs[`vehicleSlider-${this.id}`].querySelector('[data-button-next]')
      this.buttonPrev = this.$refs[`vehicleSlider-${this.id}`].querySelector('[data-button-prev]')
      this.nextSlide = this.slides[1]
    },
    setSlideNavigation(event) {
      this.slides.forEach((slide) => {
        const pos = slide.offsetLeft
        const id = +slide.dataset.sliderSlide
        if (this.slideIsIntoView(slide, event.target)) {
          console.log(`#slide-${this.id}-${id + 1}`)
          this.nextSlide = event.target.querySelector(`#slide-${this.id}-${id + 1}`)
          this.prevSlide = event.target.querySelector(`#slide-${this.id}-${id - 1}`)
        }
      })
      if (this.nextSlide) {
        this.buttonNext.href = `#${this.nextSlide.id}`
      } else {
        this.buttonNext.href = '#'
      }
      if (this.prevSlide) {
        this.buttonPrev.href = `#${this.prevSlide.id}`
      } else {
        this.buttonPrev.href = '#'
      }
    },
    slideToNext() {
      if (!this.nextSlide) return
      this.scrollToSlide(this.nextSlide)
    },
    slideToPrev() {
      if (!this.prevSlide) return
      this.scrollToSlide(this.prevSlide)
    },
    scrollToSlide(slide) {
      if (slide.scrollIntoViewIfNeeded) {
        slide.scrollIntoViewIfNeeded(false)
      } else if (slide.scrollIntoView) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      }
    },
    slideIsIntoView(slide, target) {
      const offsetLeft = slide.offsetLeft
      const targetLeft = target.scrollLeft
      if (Math.ceil(targetLeft) >= offsetLeft && targetLeft < offsetLeft + 2) {
        return true
      }
      return false
    },
  },
}
</script>
